import { useState, useCallback } from 'react';

import { api } from '@/services';
import { getErrorDetails } from '@/utils';

const useConversionDetails = ({ onUnauthorized }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const resetState = () => {
    setIsLoading(false);
    setError(null);
    setData(null);
  };

  const getDetails = useCallback(async (conversionId, sourceAuthId) => {
    resetState();

    setIsLoading(true);

    try {
      setData(await api.getConversionDetails(conversionId, sourceAuthId));
    } catch (err) {
      const { is401, is500, message } = getErrorDetails(err);

      if (is401) {
        onUnauthorized();
      } else if (is500) {
        setError('Failed to load conversion details. Refresh the page.');
      } else {
        setError(message);
      }
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { data, error, isLoading, getDetails };
};

export default useConversionDetails;
